import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/roadmap/magnifying-glass.svg'
import _imports_1 from '@/assets/images/roadmap/agreement-handshake.svg'
import _imports_2 from '@/assets/images/roadmap/discuss-the-details.svg'
import _imports_3 from '@/assets/images/roadmap/celebration.svg'


const _hoisted_1 = { id: "about-us" }
const _hoisted_2 = { id: "about-us-section" }
const _hoisted_3 = { id: "about-us-roadmap" }
const _hoisted_4 = {
  class: "section-top-text",
  id: "about-us-top-text"
}
const _hoisted_5 = { class: "section-sub-text" }
const _hoisted_6 = { id: "about-us-roadmap-card-container" }
const _hoisted_7 = { class: "about-us-roadmap-card" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "about-us-roadmap-img-container",
  id: "about-us-roadmap-one"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Step 1: search",
    class: "about-us-roadmap-img"
  })
], -1)
const _hoisted_9 = { class: "roadmap-h3" }
const _hoisted_10 = { class: "roadmap-p" }
const _hoisted_11 = { class: "about-us-roadmap-card" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "about-us-roadmap-img-container",
  id: "about-us-roadmap-two"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Step 2: agreement",
    class: "about-us-roadmap-img"
  })
], -1)
const _hoisted_13 = { class: "roadmap-h3" }
const _hoisted_14 = { class: "roadmap-p" }
const _hoisted_15 = { class: "about-us-roadmap-card" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "about-us-roadmap-img-container",
  id: "about-us-roadmap-three"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Step 3: details",
    class: "about-us-roadmap-img"
  })
], -1)
const _hoisted_17 = { class: "roadmap-h3" }
const _hoisted_18 = { class: "roadmap-p" }
const _hoisted_19 = { class: "about-us-roadmap-card" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "about-us-roadmap-img-container",
  id: "about-us-roadmap-four"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "Step 4: enjoy",
    class: "about-us-roadmap-img"
  })
], -1)
const _hoisted_21 = { class: "roadmap-h3" }
const _hoisted_22 = { class: "roadmap-p" }
const _hoisted_23 = { id: "about-us-roadmap-btn-container" }
const _hoisted_24 = {
  class: "rent-an-office-btn",
  id: "about-us-roadmap-btn",
  href: "/offices"
}
const _hoisted_25 = { id: "about-us-flex" }
const _hoisted_26 = { class: "about-us-div" }
const _hoisted_27 = { class: "about-us-p" }
const _hoisted_28 = { class: "about-us-div" }
const _hoisted_29 = { class: "about-us-p" }

import {getCurrentInstance} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutUs',
  setup(__props) {

const instance = getCurrentInstance();
const translator = instance?.appContext.config.globalProperties.$translatorUtils;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translator).trans("general.about_us.top_text")), 1),
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(translator).trans("general.about_us.sub_text")), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref(translator).trans("general.about_us.find_solution.title")), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(translator).trans("general.about_us.find_solution.description")), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("h3", _hoisted_13, _toDisplayString(_unref(translator).trans("general.about_us.agreement.title")), 1),
            _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(translator).trans("general.about_us.agreement.description")), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("h3", _hoisted_17, _toDisplayString(_unref(translator).trans("general.about_us.details.title")), 1),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(translator).trans("general.about_us.details.description")), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("h3", _hoisted_21, _toDisplayString(_unref(translator).trans("general.about_us.enjoy.title")), 1),
            _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(translator).trans("general.about_us.enjoy.description")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("a", _hoisted_24, [
            _createElementVNode("span", null, [
              _createElementVNode("strong", null, _toDisplayString(_unref(translator).trans("general.header.rent_office")), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("h3", null, _toDisplayString(_unref(translator).trans("general.about_us.challenges_title")), 1),
          _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(translator).trans("general.about_us.challenges_description")), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("h3", null, _toDisplayString(_unref(translator).trans("general.about_us.solution_title")), 1),
          _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(translator).trans("general.about_us.solution_description")), 1)
        ])
      ])
    ])
  ]))
}
}

})